import React from "react"
import { Grid } from "@mui/material"

import { AppCardTitle, AppCrudTable } from "@components"
import { userSettingTierData } from "../@signals"
import { actionsColumn, nameColumn, providersColumn } from "./columns"
import UserSettingTierDrawer from "./Drawer"
import { isTourDemoActive } from "@signals/app"
import UserSettingTierTabButton from "./Button"


export default function UserSettingTierTable() {

	return <Grid container spacing={1}>
		{(!isTourDemoActive.value || !!userSettingTierData.value?.length) && <Grid item xs={12}>
			<AppCrudTable
				// The tab's create button with the table's own actions, as every list of the app
				options={{ customToolbar: () => <UserSettingTierTabButton/> }}
				title={<AppCardTitle icon="layer-group" title="Your Tiers"/>}
				data={userSettingTierData.value}
				columns={[
					nameColumn(),
					providersColumn(),
					actionsColumn()
				]}
			/>
		</Grid>}

		<UserSettingTierDrawer />
	</Grid>
}